import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { computed, ref } from 'vue'

export default /*#__PURE__*/_defineComponent({
  props: {
  text: {
    type: String,
    default: () => '-'
  },
  textStyle: {
    type: Object
  },
  placement: {
    type: String,
    default: () => 'top'
  }
},
  setup(__props) {

const props = __props


const textComput = computed<string>(() => props.text)
const textStyleComput = computed<any>(() => props.textStyle || {})
const placementComput = computed<any>(() => props.placement)

const domRef = ref()


return (_ctx: any,_cache: any) => {
  const _component_a_tooltip = _resolveComponent("a-tooltip")!

  return (_openBlock(), _createElementBlock("div", {
    ref: (_value, _refs) => {
      _refs['domRef'] = _value
      domRef.value = _value
    },
    class: "text-columns",
    style: _normalizeStyle(_unref(textStyleComput))
  }, [
    _createVNode(_component_a_tooltip, {
      title: _unref(textComput),
      placement: _unref(placementComput)
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_unref(textComput)), 1)
      ]),
      _: 1
    }, 8, ["title", "placement"])
  ], 4))
}
}

})